export default "__VITE_ASSET__INVctN6R__"